import {ajaxHilo, getHoilUrl} from "../request";

export default {
  // 活动管理 -- 活动配置 -- 查询活动1
  getTemplateAct(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v1/actRecord/list",1), data, {
      method
    });
  },

  // 添加活动
  getAddTemplateAct(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v1/actRecord",2), data, {
      method
    });
  },

  // 编辑活动
  getEditTemplateAct(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v1/actRecord",3), data, {
      method
    });
  },

  // 删除活动
  delTemplateAct(data, method) {
    return ajaxHilo(
      "post",
      getHoilUrl(`/actMgr/v1/actRecord/${data.id}`,4),
      data,
      {
        method
      }
    );
  },

  // 复制活动
  getCopyAct(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v1/actRecord/copy",2), data, {
      method
    });
  },

  getGiftAct(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v1/actGift/config/list",1), data, {
      method
    });
  },

  getUpdateGiftAct(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v1/actGift/config/",3), data, {
      method
    });
  },

  getTaskAct(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v1/actTask/config/list",1), data, {
      method
    });
  },

  getAddTaskAct(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v1/actTask/config/",2), data, {
      method
    });
  },

  getEditTaskAct(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v1/actTask/config/",3), data, {
      method
    });
  },

  delTaskAct(data, method) {
    return ajaxHilo(
      "post",
      getHoilUrl(
        `/actMgr/v1/actTask/config/${data.activityId}/${data.taskId}`
      ,4),
      data,
      {
        method
      }
    );
  },

  getCopyTaskAct(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v1/actTask/config/copy",2), data, {
      method
    });
  },

  getAwardAct(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v1/actAward/config/list",1), data, {
      method
    });
  },

  getAddAwardAct(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v1/actAward/config",2), data, {
      method
    });
  },

  getEditAwardAct(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v1/actAward/config",3), data, {
      method
    });
  },

  delAwardAct(data, method) {
    return ajaxHilo(
      "post",
      getHoilUrl(
        `/actMgr/v1/actAward/config/${data.activityId}/${data.taskId}/${data.n}`
      ,4),
      data,
      {
        method
      }
    );
  },
}



// WEBPACK FOOTER //
// ./src/js/https/activityDeploy.js